<template>
  <SequinTag
    variant="secondary">
    {{ displayText }}
    <PlainButton
      class="p-1"
      @click="$emit('remove-filter', { filter })">
      <SvgX
        color="white"
        :width="15"
        :height="15"/>
    </PlainButton>
  </SequinTag>
</template>

<script setup>
import { computed } from 'vue'
import SvgX from '@shared/components/icons/SvgX.vue'
import SequinTag from '@/components/global/sequin/SequinTag.vue'
import PlainButton from '@/components/global/sequin/PlainButton.vue'

const props = defineProps({
  filter: {
    type: Object,
    required: true
  }
})
defineEmits(['remove-filter'])

const displayText = computed(() => {
  // Add inch symbol for inch measurement filters (inseam)
  if (props.filter.filterType === 'inseam') {
    return `${props.filter.text}"`
  }
  return props.filter.text
})
</script>
